import { getCouponWidgetDetail } from "@dineout-cart-client/helpers/cartHelper";
import { CartTransformer } from "@dineout-cart-client/helpers/cartTransformer";
import { IDineoutCartResponse } from "@dineout-cart-client/interfaces";
import { IApplyCouponWidget } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { BOOLEAN_AS_STRING } from "@swiggy-private/payment-types";

export const getApplyCouponWidget = (cartState?: IDineoutCartResponse["data"] | null): IApplyCouponWidget | null => {
    // in case showCouponWidget is undefined, coupon section needs to be shown as per backend flow
    if (!cartState || String(cartState?.showCouponWidget) === BOOLEAN_AS_STRING.FALSE || cartState?.bill?.skipPayment) {
        return null;
    }
    const transformedCart = CartTransformer(cartState);
    const applyCouponWidget = getCouponWidgetDetail(transformedCart);
    const appliedCouponDiscount = transformedCart?.bill?.dineoutPricingInfo?.totalDiscount;
    return { ...applyCouponWidget, appliedCouponDiscount };
};

export const isCouponApplied = (applyCouponWidget: IApplyCouponWidget | null) => {
    return !isEmpty(applyCouponWidget?.coupon) && !isEmpty(applyCouponWidget?.appliedCouponDiscount);
};
